
import Vue from 'vue';
import { CvButton } from '@carbon/vue';
import Close20 from '@carbon/icons-vue/es/close/20';
import imageProcessingAPI from '@/services/FileService';
import { base64StringToBlob } from 'blob-util';
import { useStore as useGlobalStore } from '@/stores/v2/global';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { mapActions, mapState } from 'pinia';
import { convertToBlob } from '@/utils/common';
import { AnnotationShape } from '../../typings/common';
import VectorizePreviewModal from './VectorizePreviewModal.vue';
import { ArtworkPayload } from '@/web-components/import-wizard/typings/pintura';

export default Vue.extend({
  name: 'VectorizeModal',
  components: {
    CvButton,
    VectorizePreviewModal,
    'close-icon': Close20,
  },
  data() {
    return {
      vectorizePreviewImageBlob: null as Blob | null,
      vectorizePreviewImageToken: '' as string,
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['isLoaderActive']),
    ...mapState(useShapeStore, ['activeShapeId', 'shapeById']),

    activeShape(): AnnotationShape | undefined {
      return this.shapeById(this.activeShapeId);
    },
  },
  methods: {
    ...mapActions(useGlobalStore, ['setIsLoaderActive']),

    async onGenerateVectorizedPreview() {
      if (this.activeShape && this.activeShape.kind === 'Logo') {
        this.setIsLoaderActive(true);

        try {
          const fileBlob = await convertToBlob(
            this.activeShape.originalFileUrl
          );

          const { data: vectorizedImage } =
            await imageProcessingAPI.vectorizeImage(fileBlob);

          this.setIsLoaderActive(false);
          this.$modal.hide('vectorize-modal');

          this.vectorizePreviewImageBlob = base64StringToBlob(
            vectorizedImage.vectorizedContentBytes,
            'image/png'
          );
          this.vectorizePreviewImageToken = vectorizedImage.imageToken;

          this.$nextTick(() => {
            this.$modal.show('vectorize-preview-modal');
          });
        } catch (error) {
          console.error('Vectorization failed:', error);
          this.setIsLoaderActive(false);
        }
      }
    },

    onPreviewReject() {
      this.$modal.hide('vectorize-preview-modal');
      this.$emit('vectorize:cancel');
    },

    onPreviewAccept(payload: ArtworkPayload) {
      this.$modal.hide('vectorize-preview-modal');
      this.$emit('vectorize:accept', payload);
    },
  },
});
